import React from 'react';

import Col from 'react-bootstrap/Col';
import postData from '../../utilities/postData';
import ListView from '../shared/lists/ListView';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import useFilter from '../../utilities/useFilter';
import UserItem from './UserItem';
import SearchBar from '../shared/search/SearchBar';

const UserView = (props) => {
    const getUrl = '/api/users/list';

    const { items, submitFilter, pageInfo, canCreate, filter, setFilter } = useFilter(getUrl, {
        searchString: '', searchObject: {
            "firstName": '',
            "lastName": '',
            "isEnabled": true,
            "initials": ''
        }
    }, true);

    const enableItem = (id) => postData('/api/users/enable', id, submitFilter);
    const disableItem = (id) => postData('/api/users/disable', id, submitFilter);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    hide="md"
                    content="Name"
                    sortName="LastName"
                    sort={pageInfo}
                />
                <SortableTh
                    content="Username"
                    sortName="UserName"
                    sort={pageInfo}
                />
                <SortableTh
                    hide="md"
                    content="User Type"
                    sortName="UserType"
                    sort={pageInfo}
                />
                {window.biztrax.franchiseId === 1 &&
                    <SortableTh
                        hide="lg"
                        content="Franchise"
                        sortName="FranchiseName"
                        sort={pageInfo}
                    />
                }
                <SortableTh
                    content="Status"
                    sortName="IsEnabled"
                    sort={pageInfo}
                    width={'75px'}
                />
                <th className="two-button-cell">
                </th>
            </tr>
        </thead>
    );

    const itemList = items.map((item) =>
        <UserItem
            item={item}
            key={item.id}
            editItem={() => window.location = `/users/edit/${item.id}`}
            disableItem={() => disableItem(item.id)}
            enableItem={() => enableItem(item.id)}
            acl={item.acl}
        />
    );

    return (
        <React.Fragment>
            <SearchBar filter={filter} setFilter={setFilter} submitFilter={submitFilter}>
                <Col xs="auto">
                        <div className="d-flex pl-sm-5" style={{ paddingTop: '5px'}}>
                            <label className="custom-control custom-checkbox d-inline-flex">
                                <input
                                    checked={filter.searchObject && filter.searchObject.isEnabled || false}
                                    className="custom-control-input"
                                    name="searchObject.isEnabled"
                                    onChange={(e) => {
                                        setFilter(e);
                                        submitFilter();
                                    }}
                                type="checkbox"
                                />
                                <span className="custom-control-label">&nbsp;</span>
                            </label>
                            <label style={{ marginLeft: '-5px' }}>
                                Hide Disabled
                            </label>
                        </div>
                    </Col>
            </SearchBar>
            <ListView
                addItem={() => window.location = '/users/edit/0'}
                canAdd={canCreate}
                itemName="User"
                items={itemList}
                tableHead={tableHead}
                animate={false}
            />
            <Row className="mt-4">
                <Col>
                    <PagedListControl {...pageInfo} />
                </Col>
            </Row>
        </React.Fragment >
    );
}

export default UserView;